export const GET_SPECIE_PROFILE = "GET_SPECIE_PROFILE";
export const RESET_SPECIE_PROFILE = "RESET_SPECIE_PROFILE";